<cms-unstyled-teaser [content$]="content$" [showIcon]="showIcon" [showTitle]="showTitle"></cms-unstyled-teaser>
